import { URL_CONSTANTS } from "../_constants";
import { ServiceHelper } from "./ServiceHelper";

// Third-party apps the user authorized through OAuth on the /2.0 developer API.
export const ConnectedAppsService = {
    list,
    update,
    revoke,
};

async function list() {
    const apps = await ServiceHelper.getRequest(URL_CONSTANTS.OAUTH_APPS);
    return apps.map(mapServerApp);
}

async function update(clientId, { allLocations, locationUids }) {
    const app = await ServiceHelper.putRequest(
        URL_CONSTANTS.OAUTH_APPS + "/" + clientId,
        { all_locations: allLocations, location_uids: locationUids },
    );
    return mapServerApp(app);
}

async function revoke(clientId) {
    await ServiceHelper.deleteRequest(URL_CONSTANTS.OAUTH_APPS + "/" + clientId);
}

function mapServerApp(app) {
    return {
        clientId: app.client_id,
        name: app.name,
        developer: app.developer,
        scopes: app.scopes,
        allLocations: app.all_locations,
        locations: app.locations,
        authorizedOn: app.authorized_on,
        lastUsedOn: app.last_used_on,
    };
}
